// extracted by mini-css-extract-plugin
module.exports = {"h1":"heading_h1__2-Hsy","h2":"heading_h2__3o0PK","h3":"heading_h3__2tziY","h4":"heading_h4__vWagD","h5":"heading_h5__1jZcG","h6":"heading_h6__3dksN","h7":"heading_h7__3aVPM"};